/**
 * @fileoverview WhatsNewDialogHeader — the title row inside a WhatsNewDialog
 * body. A Blueprint `whatsnew-gift` icon followed by an h3 heading with
 * ellipsis-truncated text. Used as the first child of the dialog body so
 * the title scrolls with the release-note list.
 *
 * Foundry mapping: `release-notes__whats-new-dialog-header__1g6dw2s` +
 * `release-notes__whats-new-dialog-title__1g6dw2s` +
 * `release-notes__gift-icon__1nwd5eg`.
 */

import { Icon, type IconName } from "@blueprintjs/core";
import type { ReactElement } from "react";

interface WhatsNewDialogHeaderProps {
  title: string;
  /** Override the leading icon. Defaults to a `flame` glyph (closest
   *  Blueprint v6 equivalent to Foundry's custom `whatsnew-gift` icon). */
  icon?: IconName;
  className?: string;
}

export function WhatsNewDialogHeader({
  title,
  icon = "flame",
  className,
}: WhatsNewDialogHeaderProps): ReactElement {
  return (
    <div data-testid="whats-new-dialog-header" className={["bp-whats-new-dialog-header", className].filter(Boolean).join(" ")}>
      <div className="bp-whats-new-dialog-title">
        <Icon icon={icon} size={20} className="bp-whats-new-gift-icon" />
        <h3 className="bp6-heading bp-whats-new-dialog-title-text">
          <div className="bp6-text-overflow-ellipsis">{title}</div>
        </h3>
      </div>
    </div>
  );
}
